<template>
  <div @click="menu = true">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="time"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="time"
          :label="label"
          append-icon="mdi-clock-time-four-outline"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="menu"
        v-model="time"
        format="24hr"
        @click:minute="$refs.menu.save(time)"
      ></v-time-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    initialTime: String
  },
  data () {
    return {
      defaultTime: '09:00',
      time: null,
      menu: false
    }
  },
  created () {
    this.time = this.initialTime || this.defaultTime
  },
  watch: {
    time (value) {
      this.$emit('change', value)
    }
  }
}
</script>
